import { TQualityBand } from 'partner360/components/qualityIndicator'

import { getPlanReviewMenuItems } from '../config/steps'
import { PlanReviewSection } from '../model/types'

import { isBelowHighQuality } from './isBelowHighQuality'

/** The topmost menu item whose quality is below High, or undefined when every item is High. */
export const getFirstSectionToReview = (
  getBand: (section: PlanReviewSection) => TQualityBand | null,
  includePlanningMeasure = false
) =>
  getPlanReviewMenuItems(includePlanningMeasure).find(({ key }) => isBelowHighQuality(getBand(key)))
    ?.key
